import React from "react";
import {
  PieChart,
  Pie,
  Tooltip,
  Cell,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "../styles/PieChart.css";

function PI_chart({ data = [] }) {
  return (
    <div className="pie-card">
      <h5 className="pie-title"
        style={{
          textAlign: "center",
          marginBottom: "30px",
          fontWeight: "600",
          color: "#333"
        }}
      >
        Total Sample Collection Across All Centers
      </h5>
      <ResponsiveContainer width="100%" height="80%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            cx="50%"
            cy="50%"
            outerRadius={120}
            labelLine={true}
            label={({ value }) => value}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.color}
                stroke="#e0e6e6"
                strokeWidth={2}
              />
            ))}
          </Pie>

          <Tooltip />
          <Legend
            verticalAlign="bottom"
            align="center"
            iconType="circle"
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default PI_chart;
